import React from "react";
import { useLessonSkip } from "../hook/useLessonSkip";
import { exclamation } from "../../../../../../../../assets/images/images";

export function LessonSkipPopup({
  skipLesson,
  setSkipLesson,
  isLoading,
  handleForm1Submit,
  ...lessonSkipProps
}) {
  const { handleSkipLesson, handleCancelSkip } = useLessonSkip({
    ...lessonSkipProps,
    setSkipLesson,
  });

  if (!skipLesson) return null;

  return (
    <form className="delete-course-form">
      <div className="delete-course-form-container" data-aos="zoom-in">
        <div className="delete-course-alert-image">
          <img src={exclamation} alt="Alert" />
        </div>

        <h2>
          Are you sure you want to skip this lesson? After assignment generation,
          lessons cannot be created.
        </h2>

        <div className="delete-course-form-btn-folder">
          {/* Cancel */}
          <button
            type="button"
            onClick={handleCancelSkip}
            style={{
              backgroundColor: "transparent",
              border: "1px solid #007bff",
              borderRadius: "6px",
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#007bff",
              cursor: "pointer",
              minWidth: "110px",
            }}
          >
            Cancel
          </button>

          {/* Skip Lesson */}
          {isLoading ? (
            <div className="loading-spinner" />
          ) : (
            <button
              type="button"
              style={{
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "6px",
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: "500",
                color: "white",
                cursor: "pointer",
                minWidth: "100px",
              }}
              onClick={(e) => handleSkipLesson(e, handleForm1Submit)}
            >
              Skip Lesson
            </button>
          )}
        </div>
      </div>
    </form>
  );
}
